import { connect } from 'react-redux';
import CustomerOnboarding from '../../components/CustomerOnboarding';

import {
  startTourMode,
  toggleCustomerOnboardingPopup
} from '../../modules/customerOnboarding/actions';

import {
  registrationRequest
} from '@xanadu/ui-shared/modules/userRegistration/actions';

import {
  setHighlightedSidebarButton
} from '../../modules/rightSidebar/actions';

const mapDispatchToProps = {
  startTourMode,
  registrationRequest,
  toggleCustomerOnboardingPopup,
  setHighlightedSidebarButton
};

function mapStateToProps(state) {
  return {
    widthSize: state.getIn(['application', 'widthSize']),
    isLoggedIn: state.getIn(['user', 'isLoggedIn']),
    firstTimeVisitor: state.getIn(['customerOnboarding', 'customerOnboardingPopupConfig', 'firstTimeVisitor']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOnboarding);
